var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-qiniu__preview-animation"},[_c('i',{staticClass:"iconfont icon-animation"})])}]

export { render, staticRenderFns }